/** Default stacking order for Google Maps Advanced Markers. */
export const MARKER_Z_INDEX_BASE = 0

/** Raised z-index so hovered/open markers render above overlapping pins. */
export const MARKER_Z_INDEX_HOVER = 1_000_000
